import { pending } from 'patronum';
import { fxGetData } from './main';

/** Передавать все эффекты раздела */
export const $isLoading = pending({
  effects: [fxGetData],
});
